import { render, staticRenderFns } from "./escalationConfiguration.vue?vue&type=template&id=30b464f0&scoped=true"
import script from "./escalationConfiguration.vue?vue&type=script&lang=js"
export * from "./escalationConfiguration.vue?vue&type=script&lang=js"
import style0 from "./escalationConfiguration.vue?vue&type=style&index=0&id=30b464f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b464f0",
  null
  
)

export default component.exports